import { render } from "./ProjectsPanel.vue?vue&type=template&id=36ae92ac&scoped=true&ts=true"
import script from "./ProjectsPanel.vue?vue&type=script&lang=ts"
export * from "./ProjectsPanel.vue?vue&type=script&lang=ts"

import "./ProjectsPanel.vue?vue&type=style&index=0&id=36ae92ac&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ae92ac"]])

export default __exports__